module.exports = __webpack_public_path__ + "img/screen-rotation.566532d1.svg";